import AOS from 'aos';
import 'aos/dist/aos.css';

if(!LayoutVars.wysiwyg){
    //$body.addClass("is-aos");
    AOS.init({});
    window.AOS=AOS;
}else{
    //$body.addClass("is-not-aos");
    //$body.removeClass("is-aos");
}


/*
document.addEventListener('aos:in', ({ detail }) => {
    if($(detail).is("[data-aos='home']")){
        console.log('animated in poster', detail);
        $body.addClass("hide-logo");
    }
});

document.addEventListener('aos:out', ({ detail }) => {
    if($(detail).is("[data-aos='home']")){
        console.log('animated out poster', detail);
        $body.removeClass("hide-logo");
    }
});
*/


function refreshDisplay(){
    let $hideLogo=$(".js-hide-logo");
    if($hideLogo.length){
        $hideLogo.each(function(){
            if($(this).isInViewport()){
                $body.addClass("hide-logo");
            }else{
                $body.removeClass("hide-logo");
            }
        })
    }else{
        if($body.is(".hide-logo")){
            $body.removeClass("hide-logo");
        }
    }
}

STAGE.on("SCROLL",function(){
    refreshDisplay();
});

window.refreshDisplay=refreshDisplay;


// WEBPACK FOOTER //
// ./fk.app/_src/components/aos.js